import React, { useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { Base_url, img_url } from '../api_url';

function EditActivity({ setrefreshget,activity, onClose,activityru }) {
  const [name, setName] = useState(activity?.name || '');
  const [nameru, setNameru] = useState(activityru?.name || '');
  const [image, setImage] = useState(null); // Хранение нового изображения
  const [imageUrl, setImageUrl] = useState(activity ? `${img_url}${activity.image.path}` : ''); // Ссылка на старое изображение

  // Функция для обработки нового файла изображения
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file); // Сохраняем новое изображение
      const fileUrl = URL.createObjectURL(file); // Показываем его в превью
      setImageUrl(fileUrl); // Обновляем URL для превью
    }
  };

  // Обработка отправки формы (создание или обновление)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Получение токена из cookies
    const token = Cookies.get('token_adminPage');

    const formData = new FormData();
    formData.append('name', name);
    formData.append('translations[ru][name]', nameru);
    if (image) {
      formData.append('image', image); // Если есть новое изображение, отправляем его
    }

    try {
      const url = activity ? `${Base_url}admin/activities/${activity.id}/update` : `${Base_url}admin/activities/create`;
      const response = await axios.post(url, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.status === true) {
        alert('Data uğurla yeniləndi');
        setrefreshget(true)
        onClose(); // Закрыть попап после успешного обновления
      } else {
        alert('Ошибка при обновлении данных');
      }
    } catch (error) {
      alert('Произошла ошибка при отправке данных.');
    }
  };

  return (
    <form className='right-content add-activity' onSubmit={handleSubmit}>
        <div className='popupMark'>

<span onClick={onClose}>X</span>
</div>
      <div className='box container-3'>
        <div className='w-40'>
          <div className='form-box'>
            <label className='form-item'>
              Başlıq[az]
              <input
                placeholder='Başlıq daxil edin'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </label>
          </div>
          <div className='form-box'>
            <label className='form-item'>
              Başlıq[ru]
              <input
                placeholder='Başlıq daxil edin'
                value={nameru}
                onChange={(e) => setNameru(e.target.value)}
                required
              />
            </label>
          </div>
        </div>
        <div className='w-60'>
          <h4>Qapaq şəkli</h4>
          <div className="add-img-wrapper">
            <label className='add-img'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-arrow-up" viewBox="0 0 16 16">
                <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z" />
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
              </svg>
              Upload image
              <input type="file" accept="image/*" onChange={handleFileChange} hidden />
            </label>

            {imageUrl && (
              <div className="image-preview">
                {/* <a href={imageUrl} target="_blank" rel="noopener noreferrer">Şəkil yükləndi. Yüklənmiş şəkilə baxın</a> */}
                <img src={imageUrl} alt='edit activity'/>
              </div>
            )}
          </div>
        </div>
      </div>
      <button className='btn' type='submit'>Yadda saxlayın</button>
    </form>
  );
}

export default EditActivity;
